<template>
  <div class="transition">
    <BasicText size="h5">Dans quel contexte effectuez-vous cette demande de rattachement ?</BasicText>
    <div class="transition-items--cards">
      <div class="icon-checkbox--container">
        <BasicIcon
          name="adherent"
          color="primary-600"
        />
        <BasicCheckbox
          label="Je suis une entreprise adhérente AKTO"
          @update:model-value="context = 'adherent'"
          :model-value="context === 'adherent'"
        />
      </div>
      <BasicAlert alert-type="info">
        <template #label>
          <basic-text size="body-m">
            Je souhaite suivre les formations de mes salariés en tant qu’entreprise relevant des
            <basic-link
              label="branches professionnelles AKTO"
              size="small"
              @link-click="redirectExterne('https://www.akto.fr/nos-secteurs-activite')"
            />
          </basic-text>
        </template>
      </BasicAlert>
    </div>
    <div class="transition-items--cards">
      <div class="icon-checkbox--container">
        <BasicIcon
          name="prestataire"
          color="primary-600"
        />
        <BasicCheckbox
          label="Je suis un prestataire de formation"
          @update:model-value="context = 'prestataire'"
          :model-value="context === 'prestataire'"
        />
      </div>
      <BasicAlert
        alert-type="info"
        alert-label="Je souhaite suivre les formations que je dispense à mes clients en tant que prestataire de formation"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types'
  import type { DemandeRattachementResult } from '../types'
  import { redirectExterne } from '@/features/shared/tools'

  type In = void
  type Out = Pick<DemandeRattachementResult, 'context'>

  const props = defineProps<CarteProps<In, Out>>()
  const emits = defineEmits<CarteEvents<Out>>()

  const context = computed({
    get: () => props.out?.context,
    set: (value) => emits('outChanged', true, { context: value }),
  })
</script>

<style lang="less" scoped>
  @import './ChoixCarte.less';

  .transition {
    gap: 32px;
  }

  .icon-checkbox--container {
    display: flex;
    gap: 16px;
    margin-left: 24px;

    svg {
      transform: scale(1.6);
      flex: none;
    }
  }

  .transition-items--cards {
    flex-direction: column;
    gap: 8px;
  }

  .checkbox {
    margin-left: 11px;
  }

  @media screen and (max-width: 720px) {
    .transition-items--cards {
      display: flex;
      flex-direction: column;
    }
  }
</style>
